module.exports = __webpack_public_path__ + "static/media/scg-icon.97f4c83b.woff2";